import React from "react";
import styles from "../../pages/styles";
import { BrainCircuit, Palette, Route, Users } from "lucide-react";

const NavigatorAbout = () => {
  return (
    <div className="bg-darkprimary flex flex-col items-center justify-center w-full py-8 md:py-10 px-4 md:px-20">
      <div className="text-center max-w-4xl mb-6 md:mb-8">
        <h2 className={`${styles.biggerheadingwhite} mb-3 md:mb-4`}>
          Building Job Skills for All Abilities
        </h2>
        <p className={`${styles.paragraphwhite}`}>
          The Navigator Program teaches practical tech skills designed for individuals of all abilities. Students learn real world skills that prepare them for careers in technology, from software development to digital design.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-8 md:gap-12 w-full max-w-6xl">
        <BenefitCard
          title="Job Ready Skills"
          img=<Users className="w-10 h-10 text-white" />
        />
        <BenefitCard
          title="Professional Tools"
          img=<BrainCircuit className="w-10 h-10 text-white" />
        />
        <BenefitCard
          title="Portfolio Building"
          img=<Palette className="w-10 h-10 text-white" />
        />
        <BenefitCard
          title="Career Pathways"
          img=<Route className="w-10 h-10 text-white" />
        />
      </div>
    </div>
  );
};

const BenefitCard = ({ title, img }) => {
  return (
    <div className="flex flex-col items-center text-center min-w-[140px] max-w-[160px]">
      <div className="mb-3">
        {img}
      </div>
      <p className={`${styles.paragraphwhite} mb-0 text-sm leading-tight`}>
        {title}
      </p>
    </div>
  );
};

export default NavigatorAbout;
